import React from 'react';
import './style.css';
import {Divider} from 'antd';
import {Link} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {setMenuRoute} from '../../../Store/Actions';
import useLocalization from '../../../Localization';

const ProfileInfo2 = () => {
  const dispatch = useDispatch();
  const {ApplicationString} = useLocalization();

  const handleMenuClose = () => {
    dispatch(setMenuRoute(true));
  };

  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  switch (true) {
    case userInfo && userInfo.role === 'admin':
    case userInfo && userInfo.role === 'super_admin':
    case userInfo && userInfo.role === 'event_manager_admin':
    case userInfo && userInfo.role === 'event_registration_admin':
      return (
        <div className='main-profile-container'>
          <div className='profile-view-container'>
            <div className='profile-user-wapper ms-auto'>
              <span>{userInfo?.first_name?.slice(0, 1)}</span>
              <div className='profile-email-text'>
                <p>{userInfo?.first_name}</p>
                <label>{userInfo?.email}</label>
              </div>
            </div>
          </div>
          <Link id='home-navigateAdmin-selectButton' to='/admin/events'>
            <li>{ApplicationString['profileViewComponent.subheading']}</li>
          </Link>

          {userInfo?.first_name ? (
            <>
              <Link to='/updateProfile'>
                <li onClick={handleMenuClose}>
                  {
                    ApplicationString[
                      'profileViewComponent.button.updateProfile'
                    ]
                  }
                </li>
              </Link>
              <Link to='/changePassword'>
                <li onClick={handleMenuClose}>
                  {
                    ApplicationString[
                      'profileViewComponent.button.changePassword'
                    ]
                  }
                </li>
              </Link>
              <Divider prefixCls='profile-divider' />
              <Link to='/jobs'>
                <li onClick={handleMenuClose}>
                  {
                    ApplicationString[
                      'profileViewComponent.button.createJobPosting'
                    ]
                  }
                </li>
              </Link>
              <Link to='/ads'>
                <li onClick={handleMenuClose}>
                  {ApplicationString['profileViewComponent.button.createAd']}
                </li>
              </Link>
              <Link to='/myCart'>
                <li>
                  {ApplicationString['profileViewComponent.button.myCart']}
                </li>
              </Link>
              <Link to='/myEvents'>
                <li onClick={handleMenuClose}>
                  {ApplicationString['profileViewComponent.button.myEvents']}
                </li>
              </Link>
            </>
          ) : null}
        </div>
      );

    case userInfo && userInfo.role === 'user':
      return (
        <div className='main-profile-container'>
          <div className='profile-view-container'>
            <div className='profile-user-wapper ms-auto'>
              <span>{userInfo?.first_name?.slice(0, 1)}</span>
              <div className='profile-email-text'>
                <p>{userInfo?.first_name}</p>
                <label>{userInfo?.email}</label>
              </div>
            </div>
          </div>
          <Link to='/updateProfile'>
            <li onClick={handleMenuClose}>
              {ApplicationString['profileViewComponent.button.updateProfile']}
            </li>
          </Link>
          <Divider prefixCls='profile-divider' />
          <Link to='/jobs'>
            <li onClick={handleMenuClose}>
              {
                ApplicationString[
                  'profileViewComponent.button.createJobPosting'
                ]
              }
            </li>
          </Link>
          <Link to='/ads'>
            <li onClick={handleMenuClose}>
              {ApplicationString['profileViewComponent.button.createAd']}
            </li>
          </Link>
          <Link to='/myCart'>
            <li>{`My Cart`}</li>
          </Link>
          <Link to='/myEvents'>
            <li onClick={handleMenuClose}>
              {ApplicationString['profileViewComponent.button.myEvents']}
            </li>
          </Link>
        </div>
      );
  }
};

export default ProfileInfo2;
